const TERMINAL_TOKEN_KEY = "timeClockTerminalDeviceToken";

export const getTerminalToken = (): string | null =>
  localStorage.getItem(TERMINAL_TOKEN_KEY);

export const setTerminalToken = (token: string): void => {
  localStorage.setItem(TERMINAL_TOKEN_KEY, token);
};

export const clearTerminalToken = (): void => {
  localStorage.removeItem(TERMINAL_TOKEN_KEY);
};
